import React, { useState } from "react";
import { useTranslations } from "@jugl-web/utils";
import { CRMAccountCard } from "../../../../components/CRMAccountCard";
import { ReactComponent as ShieldIcon } from "./assets/shield.svg";
import { ReactComponent as InfoIcon } from "./assets/info.svg";
import { ReactComponent as DocumentIcon } from "./assets/document.svg";
import { CRMInfoSection } from "../../../../components/CRMInfoSection";
import { WhatsappPinDialog } from "../WhatsappPinDialog";

export const WhatsappAuthenticationTab: React.FC = () => {
  const { t } = useTranslations();
  const [isWhatsappPinDialogOpen, setIsWhatsappPinDialogOpen] = useState(false);

  return (
    <>
      <CRMAccountCard
        title={t({
          id: "client-support-page.two-factor-authentication",
          defaultMessage: "Two-factor authentication",
        })}
        description={t({
          id: "client-support-page.whatsapp-two-factor-authentication-activated",
          defaultMessage:
            "WhatsApp account Two-factor authentication is activated",
        })}
        buttonProps={{
          text: t({
            id: "client-support-page.set-pin",
            defaultMessage: "Set PIN",
          }),
          onClick: () => setIsWhatsappPinDialogOpen(true),
        }}
        icon={ShieldIcon}
      />
      <CRMInfoSection
        title={t({
          id: "client-support-page.tools-and-tips",
          defaultMessage: "Tools & Tips",
        })}
        subtitle={t({
          id: "client-support-page.everything-you-need-to-know",
          defaultMessage: "Everything you need to know:",
        })}
        items={[
          {
            title: t({
              id: "client-support-page.purpose-two-factor-authentication",
              defaultMessage: "Purpose of Two-factor authentication:",
            }),
            icon: <DocumentIcon />,
            tips: [
              t({
                id: "client-support-page.two-factor-authentication-extra-security",
                defaultMessage:
                  "Use two-step verification to add an extra layer of security to the WhatsApp Business Client",
              }),
              t({
                id: "client-support-page.two-factor-authentication-manage-account",
                defaultMessage:
                  "When you have two-step verification enabled, any attempt to manage WhatsApp Account must be accompanied by the six-digit PIN that you create using this feature",
              }),
            ],
          },
          {
            title: t({
              id: "client-support-page.manage-two-factor-authentication",
              defaultMessage: "Manage Two-factor authentication:",
            }),
            icon: <InfoIcon />,
            tips: [
              t({
                id: "client-support-page.can-change-pin-two-factor-authentication",
                defaultMessage:
                  "You can always change PIN of Two-factor authentication",
              }),
            ],
          },
        ]}
      />
      <WhatsappPinDialog
        isOpen={isWhatsappPinDialogOpen}
        onRequestClose={() => setIsWhatsappPinDialogOpen(false)}
        initialScreen="createPin"
      />
    </>
  );
};
